import { Children, useEffect } from 'react';
import { IHiddenPostForm } from './hiddenPostForm.models';
import { LoggerInstance, handleEnv } from '@vfit/shared/data-access';

const HiddenPostForm = ({ url, params, target }: IHiddenPostForm) => {
  const removeAppVal = (str: string): string =>
    str?.replace('?app=true', '')?.replace('app=true', '');

  useEffect(() => {
    const isDevLocal = handleEnv('NODE_ENV') === 'development';
    if (isDevLocal) {
      LoggerInstance.debug('HiddenPostForm URL', url);
      LoggerInstance.debug('HiddenPostForm Params', params);
      LoggerInstance.debug('HiddenPostForm target', target);
    } else {
      LoggerInstance.debug('Redirect to FW', url);
      LoggerInstance.debug('Redirect to FW PARAM', params);
      LoggerInstance.debug('Redirect to FW target', target);
      document?.getElementById('submitButton')?.click();
    }
  }, []);

  return (
    <form
      id="checkoutForm"
      action={url}
      method="POST"
      {...(target ? { target } : {})}
      style={{
        display: 'none',
      }}
    >
      {Children.toArray(
        Object.keys(params)?.map((key: string) => {
          const param = params[key];
          return <input type="hidden" name={param?.name} value={removeAppVal(param?.value)} />;
        })
      )}
      <button type="submit" id="submitButton" />
    </form>
  );
};

export default HiddenPostForm;

